﻿import React from 'react';
import { connect } from 'react-redux';
import Lottie from 'lottie-react';
import IconHelper from '@bazooka_se/lf-icons';

import finalAnimData from '../../../AnimationFiles/thankyou.json';

const WizardFinal = (props) => {

    const {
        form: [formState, setFormState]
    } = {
        form: React.useState([]),
        ...(props.state || {})
    };

    const lottieRef = React.useRef();

    React.useEffect(() => {
        props.handleSubmit();
    }, [formState])

    React.useEffect(() => {
        if (lottieRef && lottieRef.current) {
            lottieRef.current.play();
        }
    }, [])

    return (
         <div className="wizard__question">
            <h2 className="wizard__question__heading">Tack för dina svar! Nu blir vi lite bättre på att hjälpa dig vara rätt försäkrad.</h2>
            <Lottie
                className="wizard__question__animation"
                lottieRef={lottieRef}
                autoplay={false}
                loop={false}
                animationData={finalAnimData}
            />
       
            <a className="arrow-link" href="https://www.lararforsakringar.se/gdpr/">
                Så här använder vi uppgifterna
                <span
                    dangerouslySetInnerHTML={{ __html: IconHelper('long-arrow-right').outerHTML }}>
                </span>
            </a>     
        </div>           
        )
    }

export default connect(null)(WizardFinal);
